// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import stat from '@infrastructure/shared/constant'
// ** Axios Imports
import axios from 'axios'

export const getGrade = createAsyncThunk('appInitialProjek/getGrade', async params => {
  const response = await axios.get(stat.URL_GRADE_ALL, { params })
  return {
    data: response.data
  }
})

export const getGuru = createAsyncThunk('appInitialProjek/getGuru', async params => {
  const add_url = "list"
  const response = await axios.get(stat.URL_GURU + add_url, { params })
  console.log(response.data)
  return response.data
})

export const getTemaByKodeGrade = createAsyncThunk('appInitialProjek/getTemaByKodeGrade', async (kode_grade, {params, getState })  => {
  const add_url = "tema/"
  const response = await axios.get(stat.URL_PROJEK + add_url +  kode_grade, { params })
  console.log('current state:', getState())
  return response.data
})

export const getProjekByKodeGrade = createAsyncThunk('appInitialProjek/getProjekByKodeGrade', async (kode_grade, {params, getState })  => {
  const add_url = "list/"
  const response = await axios.get(stat.URL_PROJEK + add_url + kode_grade, { params })
  console.log('current state:', getState())
  console.log(response.data)
  return response.data
})

export const postProjek = createAsyncThunk('appInitialProjek/postProjek', async (request, { dispatch, getState }) => {
  const add_url = "add"
  const response = await axios.post(stat.URL_PROJEK + add_url, request)
  await dispatch(getProjekByKodeGrade(getState().initialprojek.kodeGrade))
  return response.data
})

export const putProjek = createAsyncThunk('appInitialProjek/putProjek', async (request, { dispatch, getState }) => {
  const add_url = "put/"
  const response = await axios.put(stat.URL_PROJEK + add_url + request.id, request.payload)
  await dispatch(getProjekByKodeGrade(getState().initialprojek.kodeGrade))
  return response.data
})

export const delProjek = createAsyncThunk('appInitialProjek/delProjek', async (id, { dispatch, getState }) => {
  const add_url = "del/"
  const response = await axios.delete(stat.URL_PROJEK + add_url + id)
  await dispatch(getProjekByKodeGrade(getState().initialprojek.kodeGrade))
  return response.data
})

export const appInitialProjekSlice = createSlice({
  name: 'appInitialProjek',
  initialState: {
    grade: {},
    statusLoadGrade: null,
    projek: [],
    statusProjekByKodeGrade: null,
    tema: [],
    statusTemaByKodeGrade: null,
    guru: [],
    statusGuru: null,
    selectedProjek: {},
    kodeGrade: null,
    idProjek: null,
    statusDelProjek: null,

    statusPostProjek: null,
    statusPutProjek: null,
    responsePostProjek: null, 
    responsePutProjek: null, 

    // selectedTask: {},
    params: {
      filter: '',
      q: '',
      sort: '',
      tag: ''
    }
  },
  reducers: {
    selectIdProjek: (state, action) => {
      state.idProjek = action.payload
    },
    selectKodeGrade: (state, action) => {
      state.kodeGrade = action.payload
    },
    selectProjek: (state, action) => {
      state.selectedProjek = action.payload
    },
    stateResetProjek: (state) => {
      state.statusDelProjek = "loading"
      state.statusPostProjek = "loading"
      state.statusPutProjek = "loading"
    }
  },
  extraReducers: builder => {
    builder.addCase(getGrade.fulfilled, (state, action) => {
      state.grade = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getGuru.pending, (state, action) => {
      console.log("loading", action.payload)
      state.statusGuru = 'loading'
    })
    builder.addCase(getGuru.fulfilled, (state, action) => {
      state.statusGuru = 'loaded'
      state.guru = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getTemaByKodeGrade.pending, (state, action) => {
      console.log("loading", action.payload)
      state.statusTemaByKodeGrade = 'loading'
    })
    builder.addCase(getTemaByKodeGrade.fulfilled, (state, action) => {
      state.statusTemaByKodeGrade = 'loaded'
      state.tema = action.payload.data
      state.params = action.payload.params
    })
    builder.addCase(getProjekByKodeGrade.pending, (state, action) => {
      console.log("loading", action.payload)
      state.statusProjekByKodeGrade = 'loading'
    })
    builder.addCase(getProjekByKodeGrade.fulfilled, (state, action) => {
      state.statusProjekByKodeGrade = 'loaded'
      state.projek = action.payload.data
      state.params = action.payload.params
    })
     // POST, PUT, DEL Projek
     builder.addCase(postProjek.pending, (state) => {
      state.statusPostProjek = 'loading'
    })
    builder.addCase(postProjek.fulfilled, (state, action) => {
      state.statusPostProjek = 'loaded'
      state.responsePostProjek = action.payload
    })
    builder.addCase(postProjek.rejected, (state, action) => {
      state.statusPostProjek = 'failed'
      state.responsePostProjek = action.error
    })

    builder.addCase(putProjek.pending, (state) => {
      state.statusPutProjek = 'loading'
    })
    builder.addCase(putProjek.fulfilled, (state, action) => {
      state.statusPutProjek = 'loaded'
      state.responsePutProjek = action.payload
    })
    builder.addCase(putProjek.rejected, (state, action) => {
      state.statusPutProjek = 'failed'
      state.responsePutProjek = action.error
    })
    // Delete projek
    builder.addCase(delProjek.pending, (state) => {
      state.statusDelProjek = 'loading'
    })
    builder.addCase(delProjek.fulfilled, (state) => {
      state.statusDelProjek = 'loaded'
    })
    builder.addCase(delProjek.rejected, (state) => {
      state.statusDelProjek = 'failed'
    })
  }
})

export const { selectIdProjek, selectProjek, selectKodeGrade, stateResetProjek } = appInitialProjekSlice.actions

export default appInitialProjekSlice.reducer
